<template>
  <el-container>
    <!-- 头部导航栏 -->
    <el-header style='height: 70px' >
      <div class='head'>
        <div class='index' @click='index1'>
          <div class='avatar_box'><img src='../assets/logo.jpg' /></div>
          <span>一个正经的非正式网站</span>
        </div>
        <div class='header'>
          <el-link
            :underline='false'
            @click='getHome'
            target='_blank'
            >首页</el-link
          >
          <el-link
            :underline='false'
            @click='blankTip'
            target='_blank'
            >地方特色</el-link
          >
          <el-link
            :underline='false'
            @click='blankTip'
            target='_blank'
            >产品大全</el-link
          >
          <el-link
            :underline='false'
            @click='blankTip'
            target='_blank'
            >商务合作</el-link
          >
          <el-link
            :underline='false'
            @click='blankTip'
            target='_blank'
            >关于我们</el-link
          >
          <el-link @click='navigat' :underline='false' target='_blank'>导航</el-link>
          <div class='logout'>
            <el-link @click='admin' :underline='false' v-show='showadmin'>
              管理员
            </el-link>
            <el-link @click='logout' :underline='false'> 退出登录 </el-link>
          </div>
        </div>
      </div>
    </el-header>

    <!-- 文章主体 -->
    <el-main>
      <img src='../assets/ban1.jpg' style='width: 100%; height: 70px;' />
      <div class='news'>
        <el-breadcrumb separator-class='el-icon-arrow-right'>
          <el-breadcrumb-item :to="{ path: '/home' }">
            首页
          </el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/more' }">
            新闻列表</el-breadcrumb-item
          >
          <el-breadcrumb-item>新闻详情</el-breadcrumb-item>
        </el-breadcrumb>
        <h1>{{ news.theme }}</h1>
        <div class='newcontent'>{{ news.text }}</div>
        <div class='date'>{{ news.releaseTime }}</div>
      </div>
    </el-main>
    <div class='footcontent'>
      地址：湖北省武汉市洪山区关山大道888号 438200 版权所有
      一个正经的非正式网站 鄂ICP备2021021940号 <br />
      咨询：0713-88888888 87713758 87713759
      传真：0713-87583759 监督电话：0713-87713651
    </div>
  </el-container>
</template>

<script>
export default {
  data () {
    return {
      // 获取新闻列表参数对象
      news: {
        id: '',
        theme: '',
        text: '',
        releaseTime: ''
      },
      showadmin: false
    }
  },
  created () {
    // 获取新闻列表
    this.getNews()
  },
  methods: {
    async getshowadmin () {
      // 转换为布尔值
      const showAdmin = window.sessionStorage.getItem('showAdmin')
      console.info('================showAdmin : ' + showAdmin)
      if (showAdmin !== null && showAdmin === 'true') {
        this.showadmin = true
      }
      console.info('================showLogin : ' + this.showadmin)
    },
    // 退出登录
    logout () {
      window.sessionStorage.clear()
      this.$router.push('/login')
    },
    // 跳转首页
    index1 () {
      this.$router.push('/home')
    },
    // 获取新闻
    async getNews () {
      const { data: res } = await this.$http.post('/news/selectNews', {
        id: this.$route.query.setid
      })
      if (res.code !== 1) return this.$message.error('获取新闻失败')
      this.news = res.body
      console.log('getNews.res: ' + res)
    },
    // 跳转管理员页面
    admin () {
      this.$router.push('/admin')
    },
    // 跳转管理员页面
    navigat () {
      this.$router.push('/navigation')
    },
    getHome () {
      // 转换为布尔值
      const token = window.sessionStorage.getItem('token')
      if (token !== null) {
        this.$router.push('/home')
      } else {
        this.$router.push('/login')
      }
    },
    blankTip () {
      // 转换为布尔值
      this.$message.info('相关功能正在建设中，请移步他处,感谢您的支持与理解！')
    }
  }
}
</script>

<style lang='less' scoped>
.el-container {
  background-color: rgb(248, 248, 248);
}
.el-header {
  position: fixed;
  top: 0;
  z-index: 999;
  width: 100%;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.6) 30%,
    rgba(0, 0, 0, 0.5) 55%,
    rgba(0, 0, 0, 0) 98%
  );
  font-weight: 900;
  font-size: 20px;
  color: rgb(255, 255, 255);
  .head,
  .index {
    display: flex;
    justify-content: center;
    align-items: center;
    .avatar_box {
      height: 60px;
      width: 60px;
      margin: 7.5px 10px 7.5px 10px;
      min-width: 60px;
      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
    .header {
      margin-left: 250px;
      .logout {
        display: inline-block;
        margin-left: 200px;
        .el-link {
          margin: 10px;
        }
      }
    }
    span {
      width: 210px;
    }
    .index {
      cursor: pointer;
    }
  }
}
.el-link {
  color: white !important;
  margin: auto 30px;
  font-size: 16px !important;
  :hover {
    color: rgb(0, 204, 255);
  }
}
.el-main {
  width: 100%;
  text-align: center;
  .el-row {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    width: 100%;
    .news {
      padding: 50px;
      background: #ffff;
      width: 800px;
      .newcontent {
        padding-top: 15px;
        text-align: justify;
        text-indent: 2em;
        line-height: 2em;
      }
      .date {
        text-align: right;
        margin-top: 5em;
      }
    }
  }
}
.footcontent {
  height: 100px;
  text-align: center;
  font-size: 12px;
  color: #b3b3b3;
  margin-top: 5em;
  padding-top: 30px;
  border-top: 1px solid #000;
}
</style>



// WEBPACK FOOTER //
// src/components/new.vue